import {Layers, WalkOfShameLayers} from "./WalkOfShameLayers";
import {WalkOfShameGameAssets} from "../WalkOfShameGameAssets";
import {WalkOfShameGameConfig} from "../WalkOfShameGameConfig";
import {TimelineLite} from "gsap";
import {WalkOfShameGameMode} from "../server/WalkOfShameGameMode";
import {WalkOfShameSound} from "../sound/WalkOfShameSound";

export class WalkOfShamePossibleWays extends PIXI.Container {
    private _waysNumber: PIXI.BitmapText;
    private _waysNumberSFS: PIXI.BitmapText;

    constructor() {
        super();

        WalkOfShameLayers.getLayer(Layers.POSSIBLE_WAYS)?.addChild(this);
        this.init();
    }

    public updatePossibleWays(isWin: boolean): void {
        let ways: number = 1;
        WalkOfShameGameConfig.SYMBOLS_COUNT_IN_REELS.forEach((count: number) => {
            ways *= count;
        });

        const prev: number = parseInt(this._waysNumber.text);
        if (prev === ways) {
            return;
        }

        if (ways === 768) {
            this._waysNumber.text = ways + "";
            this._waysNumberSFS.text = ways + "";
            return;
        }

        const tl: TimelineLite = new TimelineLite({
            onUpdate: () => {
                this.updateTextProps(Number(this._waysNumber.text));
            },
            onComplete: () => {
                this.updateTextProps(ways);
            }
        });
        tl.fromTo([this._waysNumber, this._waysNumberSFS], {text: prev + ""}, {
            text: ways + "",
            duration: 0.18
        });

        if (!isWin) {
            tl.timeScale(3);
        }
    }

    public onModeChange(mode: string): void {
        if (mode === WalkOfShameGameMode.SUPER_FREESPIN || mode === WalkOfShameGameMode.SUPER_FREESPIN_RESPIN) {
            this._waysNumber.visible = false;
            this._waysNumberSFS.visible = true;
        } else {
            this._waysNumberSFS.visible = false;
            this._waysNumber.visible = true;
        }
    }

    private init(): void {
        this._waysNumber = new PIXI.BitmapText("768", {
            fontName: WalkOfShameGameAssets.BITMAP_POSSIBLE_WAYS,
            fontSize: 8,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        this._waysNumber.anchor = new PIXI.Point(0.5);
        this._waysNumber.position.set(68, 618);

        this._waysNumberSFS = new PIXI.BitmapText("768", {
            fontName: WalkOfShameGameAssets.BITMAP_POSSIBLE_WAYS_SFS,
            fontSize: 12,
            tint: parseInt(("#ffffff").replace(/^#/, ''), 16)
        });
        this._waysNumberSFS.anchor = new PIXI.Point(0.5);
        this._waysNumberSFS.position.set(68, 618);

        this.addChild(this._waysNumber, this._waysNumberSFS);
    }

    private updateTextProps(val: number): void {
        this._waysNumber.text = Math.round(val).toString();
        this._waysNumberSFS.text = Math.round(val).toString();

        // #137
        WalkOfShameSound.soundPlayer.playTrack({
            name: WalkOfShameSound.WAYS_TICK
        });
    }
}